import { z } from 'zod';

export const mealIdSchema = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
  z.literal(3),
  z.literal(4),
  z.literal(5),
  z.literal(6),
  z.literal(7),
  z.literal(8),
  z.literal(9),
]);
export type MealId = z.infer<typeof mealIdSchema>;

export const mealTypeSchema = z.enum(['meal', 'snack']);
export type MealType = z.infer<typeof mealTypeSchema>;

export const mealSchema = z.object({
  id: mealIdSchema,
  displayOrder: z.number(),
  title: z.string(),
  enabled: z.boolean(),
  mealType: mealTypeSchema,
  startTime: z.string().optional(),
  endTime: z.string().optional(),
});
export type Meal = z.infer<typeof mealSchema>;

export const mealsConfigurationDocSchema = z.object({
  id: z.string(),
  userId: z.string(),
  meals: z.array(mealSchema),
  createdAt: z.string(),
  updatedAt: z.string(),
  deletedAt: z.string().nullable(),
});
export type MealsConfigurationDocType = z.infer<typeof mealsConfigurationDocSchema>;
